module.exports = __webpack_public_path__ + "img/dm.e791b00f.svg";